// Components
import StyledCard from '@/components/global-components/styled-card/StyledCard';
import InformationCard from '@/components/global-components/information-card/InformationCard';
import Carousel from '@/components/global-components/carousel/Carousel';

// Node Modules
import { nanoid } from 'nanoid';
import React from 'react';

// Themes
import theme from '@/themes/index';

const InstitutionPartners = ({
  content,
  unis,
  isDesktop, 
}) => {
  const getPartnerBody = (index, {
    partner, 
  }) => {
    const getInfoContainerStyle = () => {
      return isDesktop ? {
        paddingRight: '0', paddingLeft: '8.0', 
      } : {};
    };

    const getContainerStyle = () => {
      return isDesktop ? {
        flexDirection: 'row-reverse', 
      } : {};
    };

    const idText = index % 2 === 0 ? 'universities' : 'professional-accords';

    return (
      <>
        <div className='item-container' key={nanoid()}>
          <h3 id={idText}>{partner.title}</h3>
          <StyledCard
            removeImage = {index % 2 == 0}
            content={partner}
            imageStyles={{
              maxWidth: isDesktop ? '36.3125rem' : '100%',
              maxHeight: isDesktop ? '25rem' : '100%',
            }}
            containerStyle={index % 2 === 0 ? getContainerStyle() : {}}
            infoContainerStyle={index % 2 === 0 ? getInfoContainerStyle() : {}}>
            <InformationCard content={partner} showTitle={false} />
          </StyledCard>
          {partner.logoImage && (
            <div className='logo-container'>
              <img src={partner.logoImage?.url}></img>
            </div>
          )}
          {index + 1 !== content.length && <hr />}
        </div>
        <style jsx>{`

          div.item-container {
            display: flex;
            flex-direction: column;
            width: 100%;
          }

          div.item-container h3,
          div.partners-container h3 {
            text-align: center;
            padding-bottom: 1.5rem;
            line-height: 2.25rem;
            margin-block-start: 0;
            margin-block-end: 0;
            margin-inline-start: 0;
            margin-inline-end: 0;
            font-family: ${theme.fontFamilies.montserratSemiBold};
          }

          div.item-container .logo-container {
            display: flex;
            flex-direction: column;
            width: 100%;
            align-items: center;
            padding-top: 2.375rem;
          }

          hr {
            margin: 3rem 0.625rem;
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.item-container h3,
            div.partners-container h3   {
              padding-bottom: 4.3125rem;
              line-height: 5.375rem;
            }

            div.item-container .logo-container {
              align-items: flex-start;
              padding-top: 3.375rem;
            }

            hr {
              margin: 7.5rem 0.625rem;
            }
          }
        `}</style>
        <style global jsx>{`
          div.item-container .container .info-container .card-content h6 {
            font-family: ${theme.fontFamilies.montserratBold};
            padding-bottom: 1.5rem;
            margin-block-start: 0;
            margin-block-end: 0;
            margin-inline-start: 0;
            margin-inline-end: 0;
          }

          div.item-container .container .info-container .card-content p:not(.block-img) {
            margin: 0;
            padding-bottom: 1.5rem;
          
          }

          div.item-container .container .info-container .card-content p:not(.block-img) a {
            font-size: inherit;
            line-height: inherit;
            text-decoration: none;
            color: #00E065;
          }

          div.item-container .container .info-container .card-content p:not(.block-img) a:hover {
            text-decoration: underline;
          }


          div.item-container .container .info-container .card-content p.block-img {
            display: inline-block;
          }

          div.item-container .container .info-container .card-content p.block-img img {
            height: 150px;
            width: auto;
            margin-bottom: 35px;
            margin-right: 30px;
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.item-container .container .info-container .card-content p:not(.block-img) {
              text-align: justify;
            }
          }
        `}</style>
      </>
    );
  };

  return (
    <>
      <div className='partners-container'>
        <h3 id="university-partners">University Partners</h3>
        <p className='subtitle'>CPI Costa Rica holds formal alliances with various universities; students receive credits for Spanish (onsite and online) or for experiential learning:</p>
        <p className='body-text-small text-center instruction'>Check out for more details by clicking each logo</p>
        <div className="slider-universities">
          {unis.map(uni => (
            <div className='slide-uni' key={nanoid()}>
              <a href={`/university/${uni.node.meta.uid}`}><img src={uni.node.logo.url} style={{
                height:'130px',
              }}/></a>
            </div>
          ))}
        </div>
        {content.map((partner, i) => (
          <React.Fragment key={nanoid()}>
            {getPartnerBody(i, partner)}
          </React.Fragment>
        ))}
      </div>
      <style jsx>{`
        .slider-universities {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin-bottom: 30px;
        }

        .slide-uni {
          flex: 1 0 33%;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 40px;
        }

        div.partners-container {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        div.item-container h3,
        div.partners-container h3 {
          text-align: center;
          padding-bottom: 1.5rem;
          line-height: 2.25rem;
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
          font-family: ${theme.fontFamilies.montserratSemiBold};
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.item-container h3,
          div.partners-container h3   {
            padding-bottom: 0rem;
            line-height: 5.375rem;
          }

          div.item-container h3 p.subtitle,
          div.partners-container p.subtitle {
            text-align: center;
            padding-bottom: 0rem;
          }

          div.partners-container p.instruction {
            padding-bottom: 1rem;
            font-family: ${theme.fontFamilies.montserratSemiBold};
          }
        }
      `}</style>
    </>
  );
};

export default InstitutionPartners;
